module.exports = __webpack_public_path__ + "img/youtube-black.8af96f30.svg";